/**
 *
 * ResultsSjTableHead
 *
 */

import React, { memo, FunctionComponent } from 'react';
import SortIndicatorComponent from '../../../../components/SortIndicator/SortIndicator.component';
import { Sort } from '../../../../domain';

interface IProps {
  changeSort: (field: string) => void;
  sort?: Sort;
  disabledFields: string[];
}

const ResultsSETableHead: FunctionComponent<IProps> = ({
  changeSort,
  sort,
  disabledFields,
}) => {
  return (
    <thead>
      <tr>
        <th scope="col">
          <SortIndicatorComponent
            field="eaEventClassAndSort"
            name="Class"
            sort={sort}
            changeSort={changeSort} disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="sectionName"
            name="Section"
            sort={sort}
            changeSort={changeSort} disabledFields={disabledFields}
          />
        </th>
        <th scope="col" colSpan={3}>
            <SortIndicatorComponent
              field="bridleNumber"
              name="Rider/BN"
              sort={sort}
              changeSort={changeSort} disabledFields={disabledFields}
            />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="selectedResult"
            name="Place"
            sort={sort}
            changeSort={changeSort} disabledFields={disabledFields}
          />
        </th>
        <th scope="col">
          <SortIndicatorComponent
            field="riderClassStatusName"
            name="Status"
            sort={sort}
            changeSort={changeSort} disabledFields={disabledFields}
          />
        </th>
      </tr>
    </thead>
  );
};

export default memo(ResultsSETableHead);
